import { RolodexDocumentEntry } from 'features/files'
import { DocumentCategoryMetric } from 'features/libra/stepComponents/niiDataHealth/useDataHealthMetrics'

import { formatCategory, normalizeCategory } from './categoryUtils'

/**
 * Computes document category metrics from a list of uploaded documents.
 * Groups documents by their categories and counts them.
 * Returns metrics sorted alphabetically by category label.
 */
export function computeCategoryMetrics(
  documents: ReadonlyArray<RolodexDocumentEntry>
): ReadonlyArray<DocumentCategoryMetric> {
  const categoryMap = new Map<string, Set<string>>()

  documents.forEach((document: RolodexDocumentEntry) => {
    const normalizedCategories = Array.from(
      new Set(
        (document.categories.length > 0 ? document.categories : ['unknown'])
          .map(normalizeCategory)
          .filter(Boolean)
      )
    )

    normalizedCategories.forEach((category) => {
      if (!categoryMap.has(category)) {
        categoryMap.set(category, new Set())
      }
      categoryMap.get(category)!.add(document.entry_id)
    })
  })

  const metrics: ReadonlyArray<DocumentCategoryMetric> = Array.from(
    categoryMap.entries(),
    ([category, documentIds]) => ({
      category,
      categoryLabel: formatCategory(category),
      count: documentIds.size,
      documentIds: Array.from(documentIds),
    })
  )

  return metrics.toSorted((a, b) =>
    a.categoryLabel.localeCompare(b.categoryLabel)
  )
}
